import { DocumentsEnum } from '@e-origin/shared';

import { DocumentFormSchemaProps, FormDocumentsInputType } from '@components';

const PLACEHOLDERS = {
  REFERENCE_NUMBER: 'Reference Number',
  TYPE: 'Type',
};

export const TSDDocumentFormSchema: () => DocumentFormSchemaProps = () => ({
  [DocumentsEnum.PREVIOUS_DOCUMENTS]: {
    fields: {
      type: {
        type: FormDocumentsInputType.MULTI_LANG,
        code: 'CL214',
        placeholder: PLACEHOLDERS.TYPE,
        'data-pw': 'type-input',
      },
      referenceNumber: {
        type: FormDocumentsInputType.INPUT,
        placeholder: PLACEHOLDERS.REFERENCE_NUMBER,
        'data-pw': 'reference-number-input',
      },
      goodsItemIdentifier: {
        type: FormDocumentsInputType.INPUT,
        placeholder: 'Goods item identifier',
      },
    },
  },
  [DocumentsEnum.SUPPORTING_DOCUMENTS]: {
    fields: {
      type: {
        type: FormDocumentsInputType.MULTI_LANG,
        code: 'CL213',
        placeholder: PLACEHOLDERS.TYPE,
        'data-pw': 'type-input',
      },
      referenceNumber: {
        type: FormDocumentsInputType.INPUT,
        placeholder: PLACEHOLDERS.REFERENCE_NUMBER,
        'data-pw': 'reference-number-input',
      },
    },
  },
  [DocumentsEnum.TRANSPORT_DOCUMENTS]: {
    fields: {
      type: {
        type: FormDocumentsInputType.MULTI_LANG,
        code: 'CL754',
        placeholder: PLACEHOLDERS.TYPE,
      },
      referenceNumber: {
        type: FormDocumentsInputType.INPUT,
        placeholder: PLACEHOLDERS.REFERENCE_NUMBER,
      },
    },
  },
  [DocumentsEnum.ADDITIONAL_INFORMATION]: {
    fields: {
      code: {
        type: FormDocumentsInputType.MULTI_LANG,
        code: 'CL239',
        placeholder: 'Code',
      },
      text: {
        type: FormDocumentsInputType.INPUT,
        placeholder: 'Text',
      },
    },
  },
  [DocumentsEnum.ADDITIONAL_REFERENCE]: {
    fields: {
      type: {
        type: FormDocumentsInputType.MULTI_LANG,
        code: 'CL754',
        placeholder: PLACEHOLDERS.TYPE,
      },
      referenceNumber: {
        type: FormDocumentsInputType.INPUT,
        placeholder: PLACEHOLDERS.REFERENCE_NUMBER,
      },
    },
  },
});
